import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyTransactionTypes = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    

 let transactionTypes = [
        {
            key : 1,
            text : 'PO',
            value : 'PO'
        },
        {
            key : 2,
            text : 'STO',
            value : 'STO'
        },
        {
            key : 3,
            text : 'SO',
            value : 'SO'
        },
        {
            key : 4,
            text : 'Others',
            value : 'Other'
        }
    ]
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            style={{ width: '100%' }}
            onChange={handleChange}
            options={transactionTypes}
            {...props}
        />

    )
}

export default MyTransactionTypes